import format from 'date-fns/format';
import { map } from 'lodash';
import { createAction } from 'redux-actions';
import { CALL_API } from '../constants';

const toSurgery = ({ date, description, id, hospital, notes }) => ({
  date: date ? format(date, 'YYYY-MM-DD') : null,
  id,
  type: description,
  hospital: hospital,
  notes: notes,
});

const SurgeriesService = {
  getByPatientId: createAction(CALL_API, patientId => ({
    method: 'GET',
    path: `/surgeries/patient/${patientId}`,
    handleResponse: surgeries => map(surgeries, toSurgery),
    handleError: () =>
      Promise.reject(
        'We were unable to load your surgery information. Please refresh the page to try again.',
      ),
  })),

  create: createAction(CALL_API, surgeries => ({
    body: surgeries,
    method: 'POST',
    path: '/surgeries/bulk',
    handleError: () =>
      Promise.reject('Something went wrong. Please try again.'),
  })),
};

export default SurgeriesService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/surgeries/SurgeriesService.js